import { createSlice } from '@reduxjs/toolkit';
import { claimData } from '../../component/account/data/claims';
import { debtorDetailData, debtorDetailData2, debtorDetailData3, debtorSummaryData } from '../../component/account/data/debtors';
import { financialData } from '../../component/account/data/financial';

const initialState = {
    selectedAccount: null,
    searchResults: [],
    claimData: claimData,

    debtorSummaryData: debtorSummaryData,

    debtorDetailData: debtorDetailData,
    debtorDetailData2: debtorDetailData2,
    debtorDetailData3: debtorDetailData3,

    financialData: financialData,
};


const accountSlice = createSlice({
    name: 'accounts',
    initialState,
    reducers: {
        selectAccount: (state, action) => {
            state.selectedAccount = action.payload;
        },
        setSearchResults: (state, action) => {
            state.searchResults = action.payload;
        },
        clearSelectedAccount: (state) => {
            state.selectedAccount = null;
        },
        reset() {
            return initialState;
        }
    },
});

export const accountAction = accountSlice.actions;
export const accountReducer = accountSlice.reducer;
